module.exports = __webpack_public_path__ + "media/img/event/S2U_Invite-EDM-4ebc13ff82fcd0dafd88b7078449d788.jpg";